<template>
  <div>

    <div v-if="hasFetched && hasConfig" class="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-0">
      <sponsor-level-modal v-on:edited-level="editExistingLevel" modalId="editSponsorLevelModal" :existingLevel="editLevel" :existingLevelNames="existingLevelNames" />
      <sponsor-modal v-on:edited-sponsor="editExistingSponsor" modalId="editSponsorModal" :existingSponsor="editSponsor" :levels="eventSponsorConfig.levels" />
      <div class="md:col-span-2 bg-white p-3 rounded border m-2 mb-0">
        <div class="flex flex-col md:flex-row md:gap-2 md:items-center mb-2">
          <h1 class="pb-1 lg:pb-0 truncate text-2xl flex-1">Sponsor Info</h1>
          <a class="link text-sm" href="https://showman.helpscoutdocs.com/article/55-setting-up-online-sponsor-form" target="_blank">Learn more about setting up sponsors.</a>

          <div class="flex flex-wrap items-center justify-between gap-2">
            <div class="flex items-center gap-2">
              <toggle-switch label="Pass on Fees" @toggle="onFeeToggle" :toggled="eventSponsorConfig.pass_on_fees"  />
              <span class="text-gray-600">|</span>
              <div class="text-sm">Total Sponsors: {{ eventSponsors.length }}</div>
            </div>
            <dropdown-button ref="dropdownButton">
              <span slot="link" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                <!--<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                </svg>-->
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>

              </span>
              <div slot="dropdown" class="w-64 bg-white border shadow rounded-md overflow-hidden text-center divide-y divide-gray-200 text-sm">
                <div class="py-1" role="none">
                  <button class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200" @click="$refs.downloadData.exportCSVFile(`${adminData.event.name}_sponsors`,sortedEventSponsors, exportHeaders); $refs.dropdownButton.close()">
                    Download Sponsors
                  </button>
                </div>
                <!--<div class="py-1" role="none">
                </div>-->
              </div>
            </dropdown-button>
          </div>

        </div>
        <div v-if="eventSponsorConfig.levels.length === 0" class="my-4">
          <div class="block text-gray-700 font-bold mb-2">
              Getting started
            </div>
          <div>
            Start creating sponsor levels to provide sponsorship options for your event. Once sponsor levels are added, you'll see them appear on your show homepage.
          </div>
        </div>
        <div class="bg-gray-200 p-4 rounded my-2">
          <label class="block text-gray-700 font-bold mb-2" for="eventSponsorConfig.about_text">
            Sponsor Info Text
          </label>
          <textarea v-model="eventSponsorConfig.about_text" rows="3" class="text-input" placeholder="This is displayed to potential sponsors during checkout." />
          <button class="btn-green btn-sm mt-1" @click="saveAboutText">
              <span>Save Sponsor Info Text</span>
          </button>
        </div>
      </div>
      <div class="m-2 mr-1 bg-white p-3 rounded border">
        <div class="flex flex-col md:flex-row md:justify-between md:items-center mb-2">
          <h1 class="pb-1 lg:pb-0 truncate text-2xl">Sponsor Levels</h1>
          <add-sponsor-level-modal-button v-if="!isEventArchived && eventSponsorConfig.levels.length !== 0" v-on:added-level="addLevel" :existingLevelNames="existingLevelNames"/>
        </div>
        <button v-if="dirty" class="btn-blue-outline btn-sm mb-2" @click="saveLevelOrder">Save Display Order</button>
        <draggable tag="ul" v-model="eventSponsorConfig.levels" group="levels" ghost-class="ghost" handle=".handle" class="border-t">
          <sponsor-level v-for="(l) in eventSponsorConfig.levels" :key="l.name" :level="l" :isEventArchived="isEventArchived" v-on:set-edit-level="setEditLevel" v-on:remove-sponsor-level="removeLevel" :existing-sponsors-count="eventSponsors.filter(s => s.level === l.name).length"/>
          <div v-if="eventSponsorConfig.levels.length === 0" class="my-6">
            <div class="text-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 mx-auto text-gray-400">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
              </svg>
              <h3 class="mt-2 text-sm font-medium text-gray-900">No sponsor levels</h3>
              <p class="mt-1 text-sm text-gray-600">Get started by creating a new sponsor level.</p>
              <div class="mt-6">
                <add-sponsor-level-modal-button v-if="!isEventArchived" v-on:added-level="addLevel" :existingLevelNames="existingLevelNames"/>
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="m-2 ml-1 bg-white p-3 rounded border">
        <div class="flex flex-col md:flex-row md:justify-between md:items-center mb-2 pb-2 border-b">
          <h1 class="pb-1 lg:pb-0 truncate text-2xl">Sponsors</h1>
          <add-sponsor-modal-button v-if="!isEventArchived && eventSponsors.length !== 0" v-on:added-sponsor="addSponsor" :levels="eventSponsorConfig.levels"/>
        </div>
        <div v-if="eventSponsorConfig.levels.length !== 0">
          <sponsor v-for="(s) in sortedEventSponsors" :key="s.id" :sponsor="s" :isEventArchived="isEventArchived" v-on:set-edit-sponsor="setEditSponsor" v-on:remove-sponsor="removeSponsor" />
          <div v-if="eventSponsors.length === 0" class="my-6">
            <div class="text-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto h-12 w-12 text-gray-400">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
              </svg>
              <h3 class="mt-2 text-sm font-medium text-gray-900">No sponsors</h3>
              <p class="mt-1 text-sm text-gray-600">Get started by manually adding a sponsor.</p>
              <div class="mt-6">
                <add-sponsor-modal-button v-if="!isEventArchived" v-on:added-sponsor="addSponsor" :levels="eventSponsorConfig.levels"/>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="my-6 mx-2 text-center">
          <p class="text-xl font-medium mb-1">No Sponsor Levels Configured</p>
          <p>You must set up at least one sponsor level in order to add show sponsors.</p>
        </div>
      </div>
    </div>
    <div v-else-if="hasFetched">
      <div class="m-2 mr-1 bg-white p-3 rounded border">
        <h1 class="pb-1 lg:pb-0 truncate text-2xl">Sponsors</h1>
        <div class="text-gray-700 mt-2 mb-4">
            Enable sponsors to purchase sponsorships for your show.
            <p>
              <a class="link" href="https://showman.helpscoutdocs.com/article/55-setting-up-online-sponsor-form" target="_blank">Learn more about setting up sponsors.</a>
            </p>
        </div>
        <button class="btn btn-green" variant="primary" @click="addSponsorConfig">
            Set up sponsors
        </button>
      </div>
    </div>
    <DownloadData ref="downloadData"/>
  </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'
import Sponsor from '../../components/admin/sponsors/Sponsor.vue'
import SponsorLevel from '../../components/admin/sponsors/SponsorLevel.vue'
import SponsorLevelModal from '../../components/admin/sponsors/SponsorLevelModal.vue'
import SponsorModal from '../../components/admin/sponsors/SponsorModal.vue'
import AddSponsorLevelModalButton from '../../components/admin/sponsors/AddSponsorLevelModalButton.vue'
import AddSponsorModalButton from '../../components/admin/sponsors/AddSponsorModalButton.vue'
import ToggleSwitch from '../../components/admin/sponsors/ToggleSwitch.vue'
import DownloadData from '@/components/DownloadData'

export default {
  components: {
    SponsorLevel,
    AddSponsorLevelModalButton,
    AddSponsorModalButton,
    Sponsor,
    SponsorLevelModal,
    SponsorModal,
    draggable,
    ToggleSwitch,
    DownloadData
  },
  data: () => {
    return {
      editLevel: null,
      editSponsor: null,
      hasConfig: false,
      hasFetched: false,
      eventSponsorConfig: {
        about_text: '',
        levels: [],
        pass_on_fees: true
      },
      eventSponsors: [],
      originalEventSponsorConfigLevelOrder: []
    }
  },
  created () {
    this.fetchEventSponsorConfig()
  },
  methods: {
    addLevel (level) {
      this.eventSponsorConfig.levels.push(level)
      this.saveEventSponsorConfig().then(() => {
        this.notie.alert({
          type: 1,
          text: 'Sponsor level successfully added'
        })
      }).catch(() => {
        this.notie.alert({
          type: 3,
          text: 'Error adding sponsor level, please refresh and try again'
        })
      })
    },
    addSponsor ({sponsor}) {
      this.axios.post(process.env.VUE_APP_ROOT_API + `/admin/eventSponsors`, sponsor, {headers: {'showman-event-id': this.eventId}})
        .then((response) => {
          this.eventSponsors = response.data
          this.notie.alert({
            type: 1,
            text: 'Sponsor successfully created'
          })
        }).catch(() => {
          this.notie.alert({
            type: 3,
            text: 'Error creating sponsor, please refresh and try again'
          })
        })
    },
    addSponsorConfig () {
      this.axios.post(process.env.VUE_APP_ROOT_API + `/admin/eventSponsorConfigs`, {}, {headers: {'showman-event-id': this.eventId}})
        .then(() => {
          this.hasConfig = true
        }).catch(() => {
          this.notie.alert({
            type: 3,
            text: 'Error setting up sponsors, please refresh and try again'
          })
        })
    },
    editExistingLevel ({oldLevel, newLevel}) {
      const oldLevelIndex = this.eventSponsorConfig.levels.findIndex(l => l.name === oldLevel.name)
      if (oldLevelIndex > -1) {
        const levelsCopy = [...this.eventSponsorConfig.levels]
        levelsCopy[oldLevelIndex] = newLevel
        Vue.set(this.eventSponsorConfig, 'levels', levelsCopy)
      }
      this.saveEventSponsorConfig().then(() => {
        this.notie.alert({
          type: 1,
          text: 'Sponsor level successfully updated'
        })
      }).catch(() => {
        this.notie.alert({
          type: 3,
          text: 'Error updating sponsor level, please refresh and try again'
        })
      })
    },
    editExistingSponsor ({oldSponsor, newSponsor}) {
      const sponsorIndex = this.eventSponsors.findIndex(s => s.id === oldSponsor.id)
      if (sponsorIndex > -1) {
        this.eventSponsors.splice(sponsorIndex, 1, newSponsor)
        this.axios.put(process.env.VUE_APP_ROOT_API + `/admin/eventSponsors/${newSponsor.id}`, newSponsor, {headers: {'showman-event-id': this.eventId}})
          .then(() => {
            this.notie.alert({
              type: 1,
              text: 'Sponsor successfully updated'
            })
          }).catch(() => {
            this.notie.alert({
              type: 3,
              text: 'Error updating sponsor, please refresh and try again'
            })
          })
      }
    },
    fetchEventSponsorConfig () {
      this.axios.get(process.env.VUE_APP_ROOT_API + '/admin/eventSponsorConfigs', {headers: {'showman-event-id': this.eventId}})
        .then(response => {
          this.eventSponsorConfig = response.data
          this.originalEventSponsorConfigLevelOrder = response.data.levels.map(l => l.name)
          this.eventSponsors = response.data.sponsors
          this.hasConfig = true
        }).catch(e => {
          // 404
        }).finally(() => {
          this.hasFetched = true
        })
    },
    removeLevel (level) {
      const levelIndex = this.eventSponsorConfig.levels.findIndex(l => l.name === level.name)
      if (levelIndex > -1) {
        const sponsorCount = this.eventSponsors.filter(s => s.level === level.name).length
        const hasSponsors = sponsorCount > 0
        const hasMultipleSponsors = hasSponsors && sponsorCount !== 1
        const sponsorCountString = hasSponsors ? ` This level has ${sponsorCount} sponsor${hasMultipleSponsors ? 's' : ''}.` : ''
        if (window.confirm(`Are you sure you want to delete ${level.name}?${sponsorCountString}`)) {
          this.eventSponsorConfig.levels.splice(levelIndex, 1)
          this.saveEventSponsorConfig().then(() => {
            this.notie.alert({
              type: 2,
              text: 'Sponsor level successfully removed'
            })
          }).catch(() => {
            this.notie.alert({
              type: 3,
              text: 'Error removing sponsor level, please refresh and try again'
            })
          })
        }
      }
    },
    removeSponsor (sponsorVal) {
      if (window.confirm('Are you sure you want to delete this sponsor?')) {
        sponsorVal.deleted_at = new Date()
        const sponsorIndex = this.eventSponsors.findIndex(s => s.id === sponsorVal.id)
        this.axios.put(process.env.VUE_APP_ROOT_API + `/admin/eventSponsors/${sponsorVal.id}`, sponsorVal, {headers: {'showman-event-id': this.eventId}})
          .then(() => {
            this.eventSponsors.splice(sponsorIndex, 1)
            this.notie.alert({
              type: 1,
              text: 'Sponsor successfully updated'
            })
          }).catch(() => {
            this.notie.alert({
              type: 3,
              text: 'Error updating sponsor, please refresh and try again'
            })
          })

        /* this.axios.delete(process.env.VUE_APP_ROOT_API + `/admin/eventSponsors/${sponsorVal.id}`, {headers: {'showman-event-id': this.eventId}})
          .then((response) => {
            this.eventSponsors = response.data
            this.notie.alert({
              type: 2,
              text: 'Sponsor successfully removed'
            })
          }).catch(() => {
            this.notie.alert({
              type: 3,
              text: 'Error removing sponsor, please refresh and try again'
            })
          }) */
      }
    },
    saveEventSponsorConfig () {
      return this.axios.put(process.env.VUE_APP_ROOT_API + '/admin/eventSponsorConfigs', this.eventSponsorConfig, {headers: {'showman-event-id': this.eventId}})
        .then(response => {
          this.eventSponsorConfig = response.data
          this.originalEventSponsorConfigLevelOrder = response.data.levels.map(l => l.name)
          this.eventSponsors = response.data.sponsors
        })
    },
    saveAboutText () {
      this.saveEventSponsorConfig().then(() => {
        this.notie.alert({
          type: 1,
          text: 'Info text successfully updated'
        })
      }).catch(() => {
        this.notie.alert({
          type: 3,
          text: 'Error updating info text, please refresh and try again'
        })
      })
    },
    saveLevelOrder () {
      this.saveEventSponsorConfig().then(() => {
        this.notie.alert({
          type: 1,
          text: 'Sponsor level order successfully updated'
        })
      }).catch(() => {
        this.notie.alert({
          type: 3,
          text: 'Error saving sponsor level order, please refresh and try again'
        })
      })
    },
    saveSponsor (sponsor) {
      this.axios.put(process.env.VUE_APP_ROOT_API + '/admin/eventSponsors', sponsor, {headers: {'showman-event-id': this.eventId}})
        .then(response => {
          this.eventSponsors = response.data
        })
    },
    setEditLevel (level) {
      this.editLevel = level
      this.$root.$emit('bv::toggle::modal', 'editSponsorLevelModal')
    },
    setEditSponsor (payload) {
      this.editSponsor = payload
      this.$root.$emit('bv::toggle::modal', 'editSponsorModal')
    },
    onFeeToggle () {
      this.eventSponsorConfig.pass_on_fees = !this.eventSponsorConfig.pass_on_fees
      this.saveEventSponsorConfig().then(() => {
        this.notie.alert({
          type: 1,
          text: 'Fee settings successfully updated'
        })
      }).catch(() => {
        this.notie.alert({
          type: 3,
          text: 'Error updating fee settings, please refresh and try again'
        })
      })
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    dirty () {
      // only allow saving reordering when the original levels have been reordered, not removed, modified, or added
      return JSON.stringify(this.originalEventSponsorConfigLevelOrder) !== JSON.stringify(this.eventSponsorConfig.levels.map(l => l.name)) &&
      this.eventSponsorConfig.levels.every(l => this.originalEventSponsorConfigLevelOrder.includes(l.name)) &&
      this.eventSponsorConfig.levels.length === this.originalEventSponsorConfigLevelOrder.length
    },
    existingLevelNames () {
      return this.eventSponsorConfig.levels.map(l => l.name)
    },
    eventId () {
      return this.adminData.event.event_id
    },
    isEventArchived () {
      return this.adminData.event.status === 'ARCHIVED'
    },
    sortedEventSponsors () {
      return [...this.eventSponsors].sort((a, b) => a.sponsor_name.localeCompare(b.sponsor_name))
    },
    exportHeaders () {
      let headers = [
        {
          field: 'sponsor_name',
          header: 'Sponsor Name'
        },
        {
          field: 'level',
          header: 'Level'
        },
        {
          field: 'modifier',
          header: 'Modifier'
        },
        {
          field: 'amount',
          header: 'Amount'
        },
        {
          field: 'contact_name',
          header: 'Contact Name'
        },
        {
          field: 'email',
          header: 'Email'
        },
        {
          field: 'phone_number',
          header: 'Phone Number'
        },
        {
          field: 'address',
          header: 'Address'
        },
        {
          field: 'city',
          header: 'City'
        },
        {
          field: 'state',
          header: 'State'
        },
        {
          field: 'zip',
          header: 'Zip Code'
        },
        {
          field: 'website',
          header: 'Website'
        },
        {
          field: 'comments',
          header: 'Comments'
        },
        {
          field: 'created_at',
          header: 'Created At'
        },
        {
          field: 'id',
          header: 'ID'
        }
      ]
      return headers
    }
  }
}
</script>

<style>
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

</style>
